import { AbstractClient, CompositionClient } from "@/app/client";
import {
  AppleSMSAccountCreate,
  AppleSMSAccountResponse,
  AppleSMSAccountUpdate,
  SMSApiResponse,
} from "@/app/types";

export default class APIAppleSMSSub extends CompositionClient {
  constructor(client: AbstractClient) {
    super(client);
  }

  // Account Management
  getAccounts = async (): Promise<AppleSMSAccountResponse[]> => {
    let res = await this._fetch({
      url: `/apple-sms/accounts/`,
      method: "GET",
      auth: ["OAuth2PasswordBearer"],
    });
    if (res.headers.get("Content-Type") === "application/json")
      return res.json();
    throw new Error("Bad content type");
  };

  createAccount = async (
    body: AppleSMSAccountCreate,
  ): Promise<AppleSMSAccountResponse> => {
    let res = await this._fetch({
      url: `/apple-sms/accounts/`,
      method: "POST",
      body: body,
      bodyMime: "application/json",
      auth: ["OAuth2PasswordBearer"],
    });
    if (res.headers.get("Content-Type") === "application/json")
      return res.json();
    throw new Error("Bad content type");
  };

  getAccount = async (accountId: string): Promise<AppleSMSAccountResponse> => {
    let res = await this._fetch({
      url: `/apple-sms/accounts/${accountId}`,
      method: "GET",
      auth: ["OAuth2PasswordBearer"],
    });
    if (res.headers.get("Content-Type") === "application/json")
      return res.json();
    throw new Error("Bad content type");
  };

  updateAccount = async (
    accountId: string,
    body: AppleSMSAccountUpdate,
  ): Promise<AppleSMSAccountResponse> => {
    let res = await this._fetch({
      url: `/apple-sms/accounts/${accountId}`,
      method: "PATCH",
      body: body,
      bodyMime: "application/json",
      auth: ["OAuth2PasswordBearer"],
    });
    if (res.headers.get("Content-Type") === "application/json")
      return res.json();
    throw new Error("Bad content type");
  };

  deleteAccount = async (accountId: string): Promise<SMSApiResponse> => {
    let res = await this._fetch({
      url: `/apple-sms/accounts/${accountId}`,
      method: "DELETE",
      auth: ["OAuth2PasswordBearer"],
    });
    if (res.headers.get("Content-Type") === "application/json")
      return res.json();
    throw new Error("Bad content type");
  };
}
